type PreOnboardingStep = 'SubmitEmail' | 'CheckYourEmail' | 'ErrorState' | 'CoverageRejection';

export interface Action {
  type: 'SET_STEP';
  step: PreOnboardingStep;
}

export interface PreOnboardingState {
  step: PreOnboardingStep;
  action: Action;
}

export const initialState: PreOnboardingState = {
  step: 'SubmitEmail',
  action: {
    type: 'SET_STEP',
    step: 'SubmitEmail',
  },
};

const reducer = (state: PreOnboardingState, action: Action) => {
  switch (action.type) {
  case 'SET_STEP':
    return {
      ...state,
      step: action.step,
    };
  default:
    return state;
  }
};

export default reducer;
